import "./../../../bindings/bao-searcher";
import "./../../../bindings/bao-toolbar2";
class CategoryOrgUnitTabDialog {
    CustomFilter() {
        return null;
    }
    ItemCompleteCheck() {
        return null;
    }
}
export default CategoryOrgUnitTabDialog;